<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card flat v-if="org">
                    <GroupActions   />
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex';
  import GroupActions from "@/views/groups/GroupActions";

  export default {
    components: { GroupActions},
    name: "SearchUsers",
    data() {
      return {
        groups:'groups',
        legacygroups:undefined,
          headers:[
              {text:'Name', value:'name', align: 'text-left'},
              {text: 'Total', value: 'total', align: 'text-left'}
          ],
      }
    },
    computed:{
      ...mapState(['org', 'icons','archivedgroups'])
    },
    watch:{

    },
    mounted() {

    },
    methods: {
      ...mapActions(['get','post','getActiveGroups']),
      async renameGroup(e) {
            let data = {
                name: e.name,
                sortkey: e.sortkey
            }
            this.post({path:'api/groups/renamegroupv2',body:data})
          this.getActiveGroups()
      },
      async getLegacy(){
          this.legacygroups = await this.get({path:'api/groups/getallv3'});
      }
    }
  }
</script>

<style scoped>

</style>